import CorporateCourseMenuRedirectMiddleware from '@/middleware/CorporateCourseMenuRedirectMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'course-meetings-view',
        path: '/courses/:courseId/meetings',
        component: () => import('@/pages/courses/meetings/MeetingsIndex.vue'),
        beforeEnter: CorporateCourseMenuRedirectMiddleware,
        props: route => ({
            courseId: Number.parseInt(route.params.courseId, 10),
        }),
        meta: {
            title: 'Course Meetings',
            // opt into full-width via meta.dataTablePage
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view all', subject: 'meetings' },
        },
    },

    {
        name: 'course-meeting-view',
        path: '/courses/:courseId/meetings/:meetingId',
        component: () => import('@/pages/courses/meetings/MeetingView.vue'),
        beforeEnter: CorporateCourseMenuRedirectMiddleware,
        props: route => ({
            courseId: Number.parseInt(route.params.courseId, 10),
            meetingId: Number.parseInt(route.params.meetingId, 10),
        }),
        meta: {
            title: 'Course Meetings',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'meeting' },
        },
    },
];
